
import { computed, defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import Container from '@/components/form/container/Container.vue'
import SimpleTableForSingleSelect from '@/components/table/simple/SimpleTableForSingleSelect.vue'
import { getCompanyByCompanyCode, updatePaymentBank } from '@/apis/paymentSlip/paymentSlip'
import { CompanyBankModel } from '@/model/master-data/companyModel'
import { SlipWorkUpdatePaymentBank } from '@/model/paymentSlip/paymentSlipModel'

export default defineComponent({
  name: 'PaymentSelectCompanyDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    dataId: {
      type: Number,
      required: true
    },
    isSub: {
      type: Boolean,
      required: true
    },
    companyCode: {
      type: String,
      default: ''
    },
    companyBankId: {
      type: Number,
      default: 0
    }
  },
  components: { SimpleTableForSingleSelect, Container },
  emits: ['update:modelValue', 'refresh'],
  setup(props, context) {
    const { t } = useI18n()
    const tableRef = ref()
    // 使用 computed 实现双向绑定
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: (value) => context.emit('update:modelValue', value)
    })
    const companyBankTableStruct = [
      { prop: 'code', label: t('pay.bankCode') },
      { prop: 'name', label: t('pay.bankName') },
      { prop: 'account', label: t('pay.bankAccount') }
    ]
    const dataMap = reactive({
      tableData: Array<CompanyBankModel>(),
      listLoading: true,
      columnStruct: companyBankTableStruct,
      defaultBankId: 0,
      async getCompanyBankList() {
        dataMap.listLoading = true
        const data = await getCompanyByCompanyCode(props.companyCode)
        if (data && data.data && data.data.companyBanks.length > 0) {
          dataMap.tableData = data.data.companyBanks
          dataMap.defaultBankId = props.companyBankId
          tableRef.value.setSelectedRow(dataMap.defaultBankId)
        } else {
          dataMap.tableData = []
        }
        tableRef.value.clearSelection()
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    const handleCancel = () => {
      dialogVisible.value = false
    }
    const handleConfirm = async() => {
      const param: SlipWorkUpdatePaymentBank = {
        isSubWork: props.isSub,
        workId: props.dataId,
        workSubId: props.dataId,
        companyBankId: tableRef.value.getSelectionRow()
      }
      const res = await updatePaymentBank(param)
      if (res?.data && res?.data > 0) {
        ElMessage({
          message: t('common.setSuccess'),
          type: 'success',
          duration: 2000
        })
        context.emit('refresh')
        dialogVisible.value = false
      } else {
        ElMessage({
          message: res?.msg,
          type: 'error',
          duration: 2000
        })
      }
    }
    onMounted(() => {
      dataMap.getCompanyBankList()
    })
    return {
      t,
      tableRef,
      dialogVisible,
      handleCancel,
      handleConfirm,
      ...toRefs(dataMap)
    }
  }
})
